export const navigation = {
  home: '/',
  login: '/login',
  not_found: '/404',
  editor: '/editor',
  profile: '/profile',
  team: '/team',
  request: '/request',
  documentation: '/documentation',
  dashboard: '/dashboard',
  helpcenter: '/help-center',
  notifications: '/notifications',
  article_details: '/article/:articleId',
  request_details: '/request/:requestId',
};
